import React from 'react';

import { Col, Collapse, Panel, Row } from 'redpoints-front-components/index';

import AuditResultsFiltersActions from './AuditResultsFiltersActions';
import AuditResultsFiltersAuditorAsset from './AuditResultsFiltersAuditorAsset';
import AuditResultsFiltersTotalResults from './AuditResultsFiltersTotalResults';
import { translate } from '../../../helpers/languageHelper';

const FILTER_PANEL_KEY = 'auditResultsPanel-1';

const AuditResultsFilters = () => (
  <Collapse defaultActiveKey={FILTER_PANEL_KEY}>
    <Panel
      key={FILTER_PANEL_KEY}
      header={translate('auditResults.filters.headerPanel')}
      extra={<AuditResultsFiltersTotalResults />}
    >
      <Row>
        <Col span={4}>
          <AuditResultsFiltersAuditorAsset />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <AuditResultsFiltersActions />
        </Col>
      </Row>
    </Panel>
  </Collapse>
);

export default AuditResultsFilters;
